import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import PhotoPlaceholder from '../components/photo-placeholder';
import Testimonials from '../components/testimonials';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';
import { eyebrow, h1, pageWrap } from '../lib/styles';

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const Row = ({ icon: Icon, label, children, warn }) => (
  <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
    <span style={{ color: 'var(--rose-600)', flex: 'none', marginTop: 2 }}>
      <Icon size={20} strokeWidth={1.7} />
    </span>
    <div>
      <div
        style={{
          fontSize: 11,
          letterSpacing: '.18em',
          textTransform: 'uppercase',
          color: 'var(--ink-500)',
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      {children}
      {warn && <div style={{ fontSize: 12, color: 'var(--caution)', marginTop: 3 }}>{warn}</div>}
    </div>
  </div>
);

const Contact = () => (
  <>
    <div style={pageWrap}>
      <span style={eyebrow}>Contacto</span>
      <h1 style={{ ...h1, marginBottom: '4vw' }}>Estamos cerca</h1>
      <div
        className="z-split-grid"
        style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '4vw', alignItems: 'start' }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <Row icon={Phone} label="Teléfono y WhatsApp">
            <a href={telLink} style={{ fontFamily: 'var(--font-display)', fontSize: 28, color: 'var(--ink-900)' }}>
              {BUSINESS.telefono}
            </a>
          </Row>
          <Row icon={Mail} label="Email" warn="Placeholder · confirmar correo">
            <a href={`mailto:${BUSINESS.email}`} style={{ fontSize: 17, color: 'var(--ink-800)' }}>
              {BUSINESS.email}
            </a>
          </Row>
          <Row icon={MapPin} label="Ubicación" warn="Placeholder · confirmar dirección exacta">
            <div style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--ink-800)' }}>{BUSINESS.direccion}</div>
          </Row>
          <Row icon={Clock} label="Horario">
            {BUSINESS.horario.map((h) => (
              <div
                key={h.dia}
                style={{
                  display: 'flex',
                  gap: 20,
                  justifyContent: 'space-between',
                  fontSize: 15,
                  color: 'var(--ink-700)',
                  padding: '3px 0',
                  minWidth: 230,
                }}
              >
                <span>{h.dia}</span>
                <span style={{ color: 'var(--ink-600)' }}>{h.hora}</span>
              </div>
            ))}
          </Row>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 4 }}>
            {BUSINESS.redes.map((r) => (
              <a
                key={r.nombre}
                href={r.url}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 9,
                  border: '1px solid var(--ink-200)',
                  background: '#FFF',
                  borderRadius: 'var(--radius-pill)',
                  padding: '10px 18px',
                  fontSize: 13,
                  color: 'var(--ink-700)',
                }}
              >
                {r.nombre}
              </a>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <PhotoPlaceholder
            label="Mapa incrustado en producción. El pin abre la navegación directa al salón."
            nota="Google Maps"
            ratio="4/3"
            tone="ink"
          />
          <a
            href={BUSINESS.mapsLink}
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 10,
              background: 'var(--rose-700)',
              color: '#FFF',
              fontSize: 14,
              letterSpacing: '.06em',
              padding: 16,
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Cómo llegar
          </a>
          <div style={{ display: 'flex', gap: 10 }}>
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              style={{
                flex: 1,
                textAlign: 'center',
                border: '1px solid var(--rose-300)',
                color: 'var(--rose-700)',
                fontSize: 13.5,
                letterSpacing: '.06em',
                padding: 14,
                borderRadius: 'var(--radius-pill)',
              }}
            >
              WhatsApp
            </a>
            <a
              href={telLink}
              style={{
                flex: 1,
                textAlign: 'center',
                border: '1px solid var(--rose-300)',
                color: 'var(--rose-700)',
                fontSize: 13.5,
                letterSpacing: '.06em',
                padding: 14,
                borderRadius: 'var(--radius-pill)',
              }}
            >
              Llamar
            </a>
          </div>
        </div>
      </div>
    </div>
    <Testimonials />
  </>
);

export default Contact;
